import React from 'react';
import { createAppSwitcherBffAvailableProductsProvider } from './app-switcher-bff-available-products-provider';
const {
  fetchMethod: fetchAppSwitcherBffAvailableProducts,
  ProviderComponent: DefaultBffDataProviderComponent
} = createAppSwitcherBffAvailableProductsProvider();
export const AvailableProductsProvider = ({
  children
}) => /*#__PURE__*/React.createElement(DefaultBffDataProviderComponent, null, children);
export const prefetchAvailableProducts = () => fetchAppSwitcherBffAvailableProducts({});
export const resetAvailableProducts = () => fetchAppSwitcherBffAvailableProducts.reset();